<template>
  <main id="vendors-single" class="site-main">
    <div class="section-menu">
      <ul class="show-for-large">
        <!--<li class="section-menu__item active" @click="showSection($event, 'details')">Details</li>-->
        <li class="section-menu__item active" @click="showSection($event, 'commissions')">
          Commissions
        </li>
        <li class="section-menu__item" @click="showSection($event, 'unpaid')"
            v-if="$store.state.shop.myshopify_domain === 'waxpackcity.myshopify.com'">
          Unpaid Orders
        </li>
        <li class="section-menu__item" @click="showSection($event, 'payouts')">Payouts</li>
        <li class="section-menu__item" @click="showSection($event, 'products')">Products</li>
        <li class="section-menu__item" @click="showSection($event, 'product-types')">Product Types</li>
        <li class="section-menu__item" @click="showSection($event, 'settings')">Settings</li>
      </ul>

      <div class="select-field hide-for-large">
        <select id="section-menu" @change="showSectionSelect($event)">
          <!--<option value="details">Details</option>-->
          <option value="commissions">Commissions</option>
          <option value="settings"
                  v-if="$store.state.shop.myshopify_domain === 'waxpackcity.myshopify.com'">
            Unpaid Orders</option>
          <option value="payouts">Payouts</option>
          <option value="products">Products</option>
          <option value="product-types">Product Types</option>
          <option value="settings">Settings</option>
        </select>

        <i class="fas fa-sort"></i>
      </div>
    </div>

    <div class="grid-x grid-padding-x">
      <div class="cell">
        <div class="section-area">
          <div class="grid-container">
            <div class="grid-x grid-padding-x" v-if="vendor">
              <div class="cell">
                <div class="grid-x grid-padding-x" style="padding-bottom: 20px;">
                  <div class="cell auto" v-if="vendor.next_prev">
                    <span class="icon-action"
                          @click="$router.push('/vendors/' + vendor.next_prev.prev.id)">
                      <i class="far fa-arrow-left"></i>
                      <span>{{ vendor.next_prev.prev.name }}</span>
                    </span>
                  </div>

                  <div class="cell auto text-right" v-if="vendor.next_prev">
                    <span class="icon-action"
                          @click="$router.push('/vendors/' + vendor.next_prev.next.id)">
                        <span>{{ vendor.next_prev.next.name }}</span>
                        <i class="far fa-arrow-right"></i>
                      </span>
                  </div>
                </div>
              </div>

              <div class="welcome cell large-auto">
                <div class="grid-x align-middle">
                  <div class="cell shrink">
                    <div class="vendor-card__image">
                      <div class="vendor-card__image__inner">
                        <div class="vendor-card__image__missing"><i class="fas fa-user"></i></div>
                      </div>
                    </div>
                  </div>

                  <div class="cell auto">
                    <div class="welcome__title">
                      {{ vendor.name }}
                      <span v-if="vendor.contact_name !== null">{{ vendor.contact_name }}</span>
                    </div>

                    <ul class="vendor__contact">
                      <li>
                        <span class="vendor__contact__icon"><i class="fas fa-envelope"></i></span>
                        {{ vendor.email }}
                      </li>

                      <li>
                        <span class="vendor__contact__icon"><i class="fas fa-mobile"></i></span>
                        {{ vendor.phone }}
                      </li>

                      <li>
                        <span class="vendor__contact__icon"><i class="fab fa-paypal"></i></span>
                        {{ vendor.paypal_email }}
                      </li>

                      <li>
                        <span class="vendor__contact__icon"><i class="fas fa-money-check-alt"></i></span>
                        {{ vendor.pay_type }}
                      </li>

                      <li>
                      <span class="vendor__contact__icon">
                        <i class="fas fa-map-marker"></i></span>
                        <span v-html="vendor.full_address"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="stats cell large-shrink">
                <div class="grid-x">
                  <div class="cell auto label warning">
                    <div class="label__heading">Due</div>
                    <div class="label__content">{{ totals.commission_due }}</div>
                  </div>

                  <div class="cell auto label success">
                    <div class="label__heading">Paid</div>
                    <div class="label__content">{{ totals.commission_paid }}</div>
                  </div>

                  <div class="cell auto label">
                    <div class="label__heading">Earned</div>
                    <div class="label__content">{{ totals.commission_earned }}</div>
                  </div>

                  <div class="cell auto label" v-if="$store.state.shop.myshopify_domain === 'royal-bison-fair.myshopify.com'">
                    <div class="label__heading">Taxes</div>
                    <div class="label__content">{{ totals.amount_taxed }}</div>
                  </div>

                  <div class="cell auto label" v-if="$store.state.shop.myshopify_domain === 'cutting-tool-pickers-1.myshopify.com'">
                    <div class="label__heading">Sales</div>
                    <div class="label__content">{{ totalSales }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!--
            <div id="details" class="section-content" style="display: block;">
              <div class="grid-x grid-margin-x">
                <div class="panel cell large-8 xlarge-6 small-order-1">
                  <chart></chart>
                </div>

                <div
                  class="panel cell small-auto medium-6 xlarge-6 small-order-3 medium-order-3 xlarge-2">
                  <div class="panel__header">
                    <h3 class="panel__title">Recent Payouts</h3>
                  </div>

                  <recentPayouts :vendor_id="$route.params.id"></recentPayouts>
                </div>
              </div>
            </div>
            -->

            <div id="commissions" class="section-content" style="display: block;">
              <commissions :vendorId="$route.params.id"
                           :vendorName="vendor.name"
                           :vendor="vendor"
                           :vendorPayPalEmail="vendor.paypal_email"
                           :collectsTax="vendor.collects_tax"
                           :key="vendorReload" v-if="vendor.name"></commissions>
            </div>

            <div id="unpaid" class="section-content"
                 v-if="$store.state.shop.myshopify_domain === 'waxpackcity.myshopify.com'">
              <unpaid :vendorId="$route.params.id"
                      :vendorName="vendor.name"
                      :vendorPayPalEmail="vendor.paypal_email"
                      :key="vendorReload"></unpaid>
            </div>

            <div id="payouts" class="section-content">
              <payouts :vendor_id="$route.params.id"></payouts>
            </div>

            <div id="products" class="section-content">
              <products :vendor_id="$route.params.id"></products>
            </div>

            <div id="product-types" class="section-content">
              <productTypes :vendor_id="$route.params.id"></productTypes>
            </div>

            <div id="settings" class="section-content">
              <div class="grid-x grid-padding-x">
                <div class="cell large-7">
                  <div class="panel text-left">
                    <div class="panel__header">
                      <h3 class="panel__title">Notes</h3>
                    </div>

                    <div :class="['loading-area', noteSaving ? 'loading' : '']">
                      <div :class="['loading-area__content', noteSaving ? 'loading' : '']">
                        <div class="panel__content">
                          <div class="form-field">
                            <label for="vendor-notes">Notes</label>

                            <textarea id="vendor-notes" rows="6"
                                      :value="vendor.note"
                                      style="box-shadow: none;"></textarea>
                          </div>
                        </div>

                        <div class="panel__footer text-right">
                          <button @click="saveNotes">Save</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="panel text-left">
                    <div class="panel__header">
                      <h3 class="panel__title">Contact Information</h3>
                    </div>

                    <div :class="['loading-area', contactSaving ? 'loading' : '']">
                      <div :class="['loading-area__content', contactSaving ? 'loading' : '']">
                        <div class="panel__content">
                          <div class="form-field">
                            <label for="contact-name">Name</label>

                            <input id="contact-name" type="text" :value="vendor.contact_name">
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-auto">
                                <label for="contact-email">Email</label>

                                <input id="contact-email" type="email" :value="vendor.email">
                              </div>

                              <div class="cell large-auto">
                                <label for="contact-phone">Phone</label>

                                <input id="contact-phone" type="tel" :value="vendor.phone">
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-auto">
                                <label for="contact-address-1">Street</label>

                                <input id="contact-address-1" type="text" :value="vendor.address_1">
                              </div>

                              <div class="cell large-shrink">
                                <label for="contact-address-2">Apartment, suite, etc.</label>

                                <input id="contact-address-2" type="text"
                                       :value="vendor.address_2">
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-auto">
                                <label for="contact-city">City</label>

                                <input id="contact-city" type="text" :value="vendor.city">
                              </div>

                              <div class="cell large-2">
                                <label for="contact-state">State</label>

                                <input id="contact-state" type="text" :value="vendor.state">
                              </div>

                              <div class="cell large-3">
                                <label for="contact-zip">zip</label>

                                <input id="contact-zip" type="text" :value="vendor.zip">
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="panel__footer text-right">
                          <button @click="saveContact">Save</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="cell auto">
                  <div class="panel">
                    <div class="panel__header">
                      <h3 class="panel__title">Actions</h3>
                    </div>

                    <div :class="['loading-area', inviteSending ? 'loading' : '']">
                      <div :class="['loading-area__content', inviteSending ? 'loading' : '']">
                        <div class="panel__content">
                          <button v-if="vendor.email" @click="invite">Invite to
                            Create Account</button>
                          <p v-if="!vendor.email"><i>Add vendor email for more
                            options.</i></p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="panel">
                    <div class="panel__header">
                      <h3 class="panel__title">Commission Details</h3>
                    </div>

                    <div :class="['loading-area', commissionSaving ? 'loading' : '']">
                      <div :class="['loading-area__content', commissionSaving ? 'loading' : '']">
                        <div class="panel__content">
                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-rate">Commission Rate
                                  <span data-tooltip title="Commission percentage (Example: 10%). Defaults to global rate if not set.">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <div class="grid-x align-middle">
                                  <div class="cell shrink">
                                    <input id="commission-rate" class="short-input" type="text"
                                           :value="vendor.commission_rate">
                                  </div>

                                  <div class="cell shrink">
                                    <div style="padding-left: 5px;">%</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-by-profit">Flat Rate
                                  <span data-tooltip title="If flat rate is checked then the commission for this vendor will use the cost per item field in shopify and override global commission settings.">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <div id="commission-by-profit" @click="checkFlatRate"
                                     :class="['checkbox-choice', vendor.flat_rate ? 'active': '']"></div>
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-pay-type">Pay Type
                                  <span data-tooltip title="Used for internal accounting. Example: Cash, check, PayPal, etc.">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <input id="commission-pay-type" type="text"
                                       :value="vendor.pay_type">
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-by-profit">Calculate by Profit
                                  <span data-tooltip title="If using a percentage based commission this will take the rate by the sale_price minus the cost_per_item">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <div id="commission-by-profit" @click="checkByProfit"
                                     :class="['checkbox-choice', vendor.by_profit ? 'active': '']"></div>
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-by-compare-at-price">Calculate from Compare at Price
                                  <span data-tooltip title="Will operate commission calculations off of the compare at price if available otherwise it will fall back to the price.">
                                    <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <div id="commission-by-compare-at-price" @click="checkByCompareAtPrice"
                                     :class="['checkbox-choice', vendor.by_compare_at_price ? 'active': '']"></div>
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-collects-tax">Collects Tax
                                  <span data-tooltip title="Tax on products will be included in the commission payout">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <div id="commission-collects-tax" @click="checkCollectsTax"
                                     :class="['checkbox-choice', vendor.collects_tax ? 'active': '']"></div>
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="currency">Currency
                                  <span data-tooltip title="The currency used for this vendor">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <div class="select-field" style="display: inline-block; width: auto;">
                                  <select id="currency" name="currency" @change="changeCurrency($event)">
                                    <option value="-1">Global Default</option>
                                    <option v-for="(currency, key) in currencies" :key="key"
                                            :value="currency.value"
                                            :selected="vendor.currency === currency.value">
                                      {{ currency.name }}
                                    </option>
                                  </select>

                                  <i class="fas fa-sort"></i>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-paypal">PayPal Email
                                  <span data-tooltip title="The vendor's PayPal account email used for payouts">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <input id="commission-paypal" type="text"
                                       :value="vendor.paypal_email">
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-paypal">Tracking Codes
                                  <span data-tooltip title="Will assign orders with these discount codes to this vendor">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <input id="discount-codes" type="text"
                                       :value="vendor.discount_codes">
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-hidden">Hidden
                                  <span data-tooltip title="Will hide from vendor lists and global calculations">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <div id="commission-hidden" @click="checkHidden"
                                     :class="['checkbox-choice', vendor.hidden ? 'active': '']"></div>
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-hidden">Customers
                                  <span data-tooltip title="Limit commissions to orders only from the specified customers">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <button @click="editCustomer">Edit Customers</button>
                              </div>
                            </div>
                          </div>

                          <div class="form-field">
                            <div class="grid-x grid-padding-x">
                              <div class="cell large-5">
                                <label for="commission-hidden">Metafields
                                  <span data-tooltip title="This will allow you to set custom metafields for your vendor. Reach out to suppot@visceralapps.com for ways you can use these.">
                                  <i class="fas fa-question-circle"></i></span></label>
                              </div>

                              <div class="cell auto">
                                <button @click="editMetafield">Edit Metafields</button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="panel__footer text-right">
                          <button @click="saveCommission">Save</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="overlay" v-if="inviteSubmitted">
        <div class="overlay__inner">
          <div class="panel">
            <div class="panel__header">
              <span class="overlay__close" @click="closeInvite">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <p v-html="inviteSubmittedMessage"></p>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <editCustomers v-if="editCustomers"
                     :accountVendorList="accountVendorList"
                     :vendorId="$route.params.id"
                     @done="cancelEditCustomer" @save="saveEditCustomer"></editCustomers>
    </transition>

    <transition name="fade">
      <editMetafields v-if="editMetafields"
                      :vendorId="$route.params.id"
                      @done="cancelEditMetafields" @save="saveEditMetafields"></editMetafields>
    </transition>
  </main>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'
import chart from '@/pages/vendors/sections/chart'
import currencies from '@/assets/data/currencies.json'
import recentPayouts from '@/pages/vendors/sections/recentPayouts'
import commissions from '@/pages/vendors/sections/commissions'
import unpaid from '@/pages/vendors/sections/unpaid'
import payouts from '@/pages/vendors/sections/payouts'
import products from '@/pages/vendors/sections/products'
import productTypes from '@/pages/vendors/sections/productTypes'
import editCustomers from '@/globals/editCustomers'
import editMetafields from '@/globals/editMetafields'
import env from '@/mixins/env'

export default {
  name: 'vendorsSingle',
  mixins: [client, utils],
  components: {
    chart,
    recentPayouts,
    commissions,
    unpaid,
    payouts,
    products,
    productTypes,
    editCustomers,
    editMetafields
  },
  data: function () {
    return {
      editCustomers: false,
      editMetafields: false,
      currencies: currencies,
      vendorReload: 0,
      contactSaving: false,
      noteSaving: false,
      commissionSaving: false,
      vendor: {
        name: 'Vendor Name'
      },
      orderCount: 0,
      totals: {
        commission_due: '$0.00',
        commission_paid: '$0.00',
        commission_earned: '$0.00'
      },
      totalSales: 0,
      inviteSending: false,
      inviteSubmitted: false,
      inviteSubmittedMessage: 'Something went wrong. Try again later.'
    }
  },
  methods: {
    editMetafield: function () {
      this.editMetafields = true
    },
    cancelEditMetafields () {
      this.editMetafields = false
    },
    saveEditMetafields () {
      this.editMetafields = false
    },
    editCustomer: function () {
      this.editCustomers = true
    },
    cancelEditCustomer () {
      this.editCustomers = false
    },
    saveEditCustomer () {
      this.editCustomers = false
    },
    checkByProfit () {
      this.vendor.by_profit = !this.vendor.by_profit
    },
    checkByCompareAtPrice () {
      this.vendor.by_compare_at_price = !this.vendor.by_compare_at_price
    },
    checkCollectsTax () {
      this.vendor.collects_tax = !this.vendor.collects_tax
    },
    checkFlatRate () {
      this.vendor.flat_rate = !this.vendor.flat_rate
    },
    changeCurrency (e) {
      let value = e.target.value
      if (value === '-1') value = null
      this.vendor.currency = value
    },
    checkHidden () {
      this.vendor.hidden = !this.vendor.hidden
    },
    saveNotes () {
      this.noteSaving = true
      let note = document.getElementById('vendor-notes').value

      this.request('put', '/vendors/' + this.$route.params.id + '/', {
        note: note
      }).then(response => {
        this.noteSaving = false
        this.vendor.note = note
      })
    },
    closeInvite () {
      this.inviteSubmitted = false
    },
    invite () {
      this.inviteSending = true

      this.axios({
        method: 'get',
        url: env.api_root() + '/vendors/invite?shop_id=' + this.$store.state.shop.id + '&vendor_id=' + this.$route.params.id,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        this.inviteSending = false
        this.inviteSubmitted = true

        if (response.status === 200) {
          this.inviteSubmittedMessage = 'Invitation has been sent.'
        } else {
          this.inviteSubmittedMessage = 'Something went wrong. Try again later.'
        }
      }).catch((error) => {
        if (error) {
          this.inviteSending = false
          this.inviteSubmitted = true
          this.inviteSubmittedMessage = 'Something went wrong. Try again later.'
        }
      })
    },
    getVendor () {
      this.request('get', '/vendors/recalculate-totals/?shop_id=' + this.$store.state.shop.id + '&vendor_id=' + this.$route.params.id).then(response => {
        this.request('get', '/vendors/commission-totals/' + this.$route.params.id + '/').then(response => {
          response.commission_due = this.formatMoney(response.commission_due)
          response.commission_paid = this.formatMoney(response.commission_paid)
          response.commission_earned = this.formatMoney(response.commission_earned)
          response.amount_taxed = this.formatMoney(response.amount_taxed)
          this.totalSales = this.formatMoney(response.total_sales)

          this.totals = response
        })
      })
    },
    showSection (e, section) {
      let activeItems = document.getElementsByClassName('section-menu__item')

      for (let i = 0; i < activeItems.length; i++) {
        activeItems[i].className = 'section-menu__item'
      }

      let sections = document.getElementsByClassName('section-content')

      for (let i = 0; i < sections.length; i++) {
        sections[i].style.display = 'none'
      }

      document.getElementById(section).style.display = 'block'
      e.target.className = 'section-menu__item active'
    },
    showSectionSelect (e) {
      let sections = document.getElementsByClassName('section-content')

      for (let i = 0; i < sections.length; i++) {
        sections[i].style.display = 'none'
      }

      document.getElementById(e.target.value).style.display = 'block'
    },
    saveContact () {
      this.contactSaving = true

      let name = document.getElementById('contact-name').value
      let email = document.getElementById('contact-email').value
      let phone = document.getElementById('contact-phone').value
      let address1 = document.getElementById('contact-address-1').value
      let address2 = document.getElementById('contact-address-2').value
      let city = document.getElementById('contact-city').value
      let state = document.getElementById('contact-state').value
      let zip = document.getElementById('contact-zip').value

      // this.vendor.name = name
      this.vendor.name = name
      this.vendor.email = email
      this.vendor.contact_name = name
      this.vendor.phone = phone
      this.vendor.address_1 = address1
      this.vendor.address_2 = address2
      this.vendor.city = city
      this.vendor.state = state
      this.vendor.zip = zip

      let data = {
        contact_name: name,
        email: email,
        phone: phone,
        address_1: address1,
        address_2: address2,
        city: city,
        state: state,
        zip: zip
      }

      this.request('put', '/vendors/' + this.$route.params.id + '/', data).then(response => {
        response.full_address = response.address_1

        if (response.address_2) {
          response.full_address += ', ' + response.address_2
        }

        if (response.city) {
          response.full_address += ', ' + response.city
        }

        if (response.state) {
          response.full_address += ', ' + response.state
        }

        if (response.zip) {
          response.full_address += ', ' + response.zip
        }

        // if (response.full_address.length === 0) {
        //   response.full_address = 'No Address'
        // }

        this.vendor = response
        this.contactSaving = false
      })
    },
    saveCommission () {
      this.commissionSaving = true

      let rate = document.getElementById('commission-rate').value
      let paypal = document.getElementById('commission-paypal').value
      let discountCodes = document.getElementById('discount-codes').value
      // let hidden = document.getElementById('commission-hidden').value
      let recalcuate = false

      if (rate.length === 0) {
        rate = null
      }

      if (rate !== this.vendor.commission_rate) {
        recalcuate = true
      }

      recalcuate = true

      this.vendor.commission_rate = rate
      this.vendor.paypal_email = paypal
      this.vendor.discount_codes = discountCodes

      let data = {
        commission_rate: rate,
        paypal_email: paypal,
        discount_codes: discountCodes,
        hidden: this.vendor.hidden,
        currency: this.vendor.currency,
        by_profit: this.vendor.by_profit,
        by_compare_at_price: this.vendor.by_compare_at_price,
        collects_tax: this.vendor.collects_tax,
        flat_rate: this.vendor.flat_rate
      }

      let payType = document.getElementById('commission-pay-type').value
      this.vendor.pay_type = payType
      data['pay_type'] = payType

      this.request('put', '/vendors/' + this.$route.params.id + '/', data).then(response => {
        if (recalcuate) {
          this.request('get', '/orders/calculate-commissions/', {
            'vendor': this.$route.params.id
          }).then(response => {
            let start = new Date().getTime()
            let end = start

            while (end < start + 3000) {
              end = new Date().getTime()
            }

            this.request('get', '/vendors/update-commissions/' + this.$route.params.id + '/').then(response => {
              this.getVendor()
              this.vendorReload += 1
              this.commissionSaving = false
            })
          })
        } else {
          this.commissionSaving = false
        }
      })
    }
  },
  created () {
    this.request('get', '/vendors/' + this.$route.params.id + '/').then(response => {
      response.full_address = ''

      if (response.address_1) {
        response.full_address += response.address_1
      }

      if (response.address_2) {
        response.full_address += ', ' + response.address_2
      }

      if (response.city) {
        response.full_address += ', ' + response.city
      }

      if (response.state) {
        response.full_address += ', ' + response.state
      }

      if (response.zip) {
        response.full_address += ', ' + response.zip
      }

      // if (response.full_address.length === 0) {
      //   response.full_address = 'N/A'
      // }
      //
      // if (response.email.length === 0) {
      //   response.email = ''
      // }
      //
      // if (response.paypal_email.length === 0) {
      //   response.paypal_email = 'N/A'
      // }
      //
      // if (response.phone.length === 0) {
      //   response.phone = 'N/A'
      // }

      this.vendor = response
    })

    this.getVendor()
  },
  mounted () {
    let body = document.getElementsByTagName('body')[0]

    body.classList.add('section-page')
  },
  beforeDestroy () {
    let body = document.getElementsByTagName('body')[0]

    body.classList.remove('section-page')
  }
}
</script>

<style lang="scss">
@import '../../styles/mixins';
@import '../../styles/variables';

.welcome {
  &__title {
    font-size: 24px;
    font-weight: 900;
    line-height: 1;
    margin-bottom: 5px;
  }

  &__content {
    /*max-width: 600px;*/
  }
}

.stats {
  //max-width: 500px;
  padding-top: 10px;

  .grid-x {
    margin: 0 -2px;
  }

  .label {
    margin: 0 2px 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: left;

    &__heading {
      font-size: 16px;
      margin-bottom: 5px;
    }

    &__content {
      font-size: 18px;
      font-weight: 700;
      min-width: 180px;
    }
  }
}

.notifications {
  &__content {
    max-height: 300px;
    overflow: scroll;
  }
}

.vendor-card {
  &__image {
    border: 1px solid $dark-medium-gray;

    &__missing {
      background: $medium-gray !important;
    }
  }
}

.vendor {
  &__contact {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      color: $medium-gray;
      display: inline;
      font-size: 14px;
      line-height: 1;
      margin-right: 10px;
      padding-right: 13px;
      position: relative;
      white-space: nowrap;

      &:after {
        @include transform(translateY(-50%));
        background: $dark-gray;
        content: '';
        height: 10px;
        position: absolute;
        right: 0;
        top: calc(50% + 1px);
        width: 1px;
      }

      &:last-child {
        &:after {
          display: none;
        }
      }
    }

    &__icon {
      display: inline-block;
      text-align: center;
      width: 24px;
    }
  }
}

.light-theme {
  .vendor {
    &__contact {
      li {
        color: $darker-gray;

        &:after {
          background: $medium-gray;
        }
      }
    }
  }
}

@media (min-width: 641px) {
  .stats {
    .label {
      &__heading {
        font-size: 18px;
        margin-bottom: 5px;
      }

      &__content {
        font-size: 24px;
        font-weight: 700;
        min-width: 180px;
      }
    }
  }
}

@media (min-width: 641px) {
  .stats {
    padding-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vendors/single.vue